"use client";

import { MultiStepForm } from './components/MultiStepForm';
import { tradeFinanceEnquireFormConfig } from './TradeFinanceEnquireFormConfig';

export function TradeFinanceEnquireForm() {
  return (
    <MultiStepForm 
      config={tradeFinanceEnquireFormConfig}
      className="trade-finance-form"
    />
  );
} 